import axios from 'axios'
import { getAuthSession, handleAuthResponse, handleAuthError } from './auth-session'

// Instance Configuration

const instance = axios.create({
	baseURL: process.env.REACT_APP_PUBLIC_API_URL_IBM ?? "https://api.ap-southeast-a.apiconnect.ibmappdomain.cloud/nbtc-apigateway/nbtc",
})

instance.interceptors.request.use(config => {
	const session = getAuthSession()
	config.authSession = session
	config.headers.common['Authorization'] = session.token ? `Bearer ${session.token}` : ''
	config.headers.common['X-IBM-Client-Id'] = '552ae0956efbab0ebbf72afa71fb89e8'

	return config
})

instance.interceptors.response.use(handleAuthResponse, handleAuthError)

// Instance Utilities

export const adminHeader = {
	'Admin-Request': 1,
}

export default instance
